var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MainView',{attrs:{"movements":_vm.movements,"location":_vm.location,"fetchMovementsEvent":_vm.fetchMovementsEvent,"viewTitle":"Manage Movements","allowSearchByMonth":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }